export default __webpack_public_path__ + "4b30420f205485a73f1f66c59d1a659e.png";